import React, { useState, useEffect } from 'react';
import { tippspielAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import PageHeader from '../components/PageHeader';

function PodiumCard({ row, place }) {
  const placeClass = place === 1 ? 'podium-card--first' : place === 2 ? 'podium-card--second' : 'podium-card--third';
  return (
    <div className={`podium-card ${placeClass}`}>
      <div className={`rank-badge rank-badge--${place} mx-auto mb-2`}>{place}</div>
      <div className="font-bold text-white truncate">{row.username}</div>
      <div className="text-2xl font-black text-primary-light mt-1 tabular-nums">{row.totalPoints}</div>
      <div className="text-xs text-white/40 mt-1 uppercase tracking-wide">Punkte</div>
    </div>
  );
}

const TippspielLeaderboard = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { user } = useAuth();

  useEffect(() => {
    tippspielAPI.getLeaderboard()
      .then((res) => setRows(res.data || []))
      .catch((err) => setError(err.response?.data?.message || 'Rangliste konnte nicht geladen werden.'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-24">
        <span className="loading loading-spinner loading-lg text-primary" />
      </div>
    );
  }

  const top3 = rows.slice(0, 3);
  const rest = rows.slice(3);

  return (
    <div className="space-y-8">
      <PageHeader
        kicker="Tippspiel"
        title="Rangliste"
        subtitle={rows.length > 0 ? `${rows.length} Spieler in der Wertung` : 'Noch keine Wertungen'}
      />

      {error && <div className="alert-error-dark">{error}</div>}

      {top3.length >= 3 && (
        <div className="leaderboard-podium items-end max-w-2xl mx-auto">
          <PodiumCard row={top3[1]} place={2} />
          <PodiumCard row={top3[0]} place={1} />
          <PodiumCard row={top3[2]} place={3} />
        </div>
      )}

      <div className="t12-table-wrap">
        <table className="t12-table">
          <thead>
            <tr>
              <th className="w-16">Platz</th>
              <th>Spieler</th>
              <th className="text-right">Punkte</th>
              <th className="text-right hidden sm:table-cell">Tipps</th>
              <th className="text-right hidden md:table-cell">Exakt</th>
            </tr>
          </thead>
          <tbody>
            {(top3.length < 3 ? rows : rest).map((r) => {
              const isMe = String(r.userId) === String(user?.id);
              return (
                <tr key={r.userId} className={isMe ? 't12-table-row--me' : ''}>
                  <td>
                    <span className={`rank-badge ${r.rank <= 3 ? `rank-badge--${r.rank}` : ''}`}>
                      {r.rank}
                    </span>
                  </td>
                  <td>
                    <span className="font-semibold">{r.username}</span>
                    {isMe && (
                      <span className="ml-2 text-[0.65rem] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full bg-primary/25 text-primary-light">
                        Du
                      </span>
                    )}
                  </td>
                  <td className="text-right font-black text-primary-light tabular-nums">{r.totalPoints}</td>
                  <td className="text-right hidden sm:table-cell tabular-nums text-white/70">{r.tipsCount}</td>
                  <td className="text-right hidden md:table-cell tabular-nums text-white/70">{r.exactCount}</td>
                </tr>
              );
            })}
            {rows.length === 0 && !error && (
              <tr>
                <td colSpan={5} className="text-center text-white/50 py-12">
                  Noch keine Wertungen.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TippspielLeaderboard;
